import WorkIcon from "@mui/icons-material/Work";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

export function CorporateOnlyIcon() {
  const { t } = useTranslation("DocumentManagementSystem", {
    keyPrefix: "Next:DocumentManagementSystem:CorporateOnlyIcon",
  });
  return (
    <Tooltip
      title={t(
        "tooltipText",
        "This document is only available to corporate users"
      )}
    >
      <WorkIcon
        sx={{
          ml: 1,
          mb: 0.5,
          fontSize: "1rem",
          verticalAlign: "middle",
        }}
        color="action"
      />
    </Tooltip>
  );
}
